import { media } from '../../../styles';

export const SIDEBAR_WIDTH = 400;
export const MAP_HEIGHT_SMALL = 300;
const GUTTER_SIZE = 8;
const OFFSET_RIGHT = SIDEBAR_WIDTH + (GUTTER_SIZE * 2);

export const Container = props => ({
  position: 'relative',
  clear: 'both',
  width: '100%',
  paddingBottom: GUTTER_SIZE,

  '& .sea-map-inner': {
    overflow: 'hidden',
    float: 'left',
    position: 'relative',
    width: `calc(100% - ${OFFSET_RIGHT}px)`,
    backgroundColor: '#fff',
    border: `1px solid ${props.theme.default.lightest}`,
  },

  '& .maps-legend': {
    right: OFFSET_RIGHT + (GUTTER_SIZE * 2),
    bottom: (GUTTER_SIZE * 2),
  },

  height: props.height,


  '& .venue-map-reset': {
    padding: 0,
    top: 88,
    right: 7,
  },

  '& #venue-map-zoom-controls': {
    top: 8,
    right: 8,
  },

  [media('sm', { isMax: true })]: {
    overflow: 'hidden',
    paddingBottom: 0,
    border: 'none',

    '& #venue-map-zoom-controls': {
      display: 'none',
    },

    '& .venue-map-reset': {
      right: 8,
      top: 48,
    },

    '& .sea-map-inner': {
      zIndex: props.isViewingMap && !props.selectedTicket ? 100 : 0,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      float: 'none',
      width: '100%',
      height: `${MAP_HEIGHT_SMALL}px !important`,
    },

    '& .maps-legend': {
      display: 'none',
    },
  },

  '& #ticketTable': {
    display: props.isFetching ? 'none' : undefined,
  },
});

export const MapContainer = props => ({
});

const styleVenueMapButton = {
  zIndex: 101,
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',

  [media('sm')]: {
    display: 'none',
  },
};

export const ShowVenueMap = props => ({
  ...styleVenueMapButton,
  zIndex: props.selectedTicket ? 50 : 101,
  display: 'flex',
  width: '100%',
  left: 0,
  right: 0,
  height: 50,
  backgroundColor: 'rgba(255,255,255,0.87)',
  textAlign: 'center',
  fontWeight: 'bold',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'transform 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  transform: props.isViewingMap ? 'translateY(-100%)' : 'none',
  color: props.theme.primary.base,
});

export const HideVenueMap = props => ({
  display: props.isViewingMap && !props.selectedTicket ? 'flex' : 'none',
  ...styleVenueMapButton,
  right: 8,
  top: 8,
  width: 32,
  height: 32,
  backgroundColor: '#fff',
  borderRadius: '50%',
  boxShadow: '0px 1px 2px 0px rgba(53, 65, 74, 0.3)',
  cursor: 'pointer',
  userSelect: 'none',
});



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/styles.js